import { Stack, Typography } from "@mui/material";
import { formatCoinCount } from "../utils/formatters";
import { useTheme, useMediaQuery } from "@mui/material";

interface CoinCounterProps {
  coins: number;
}

export const CoinCounter = ({ coins }: CoinCounterProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallPhone = useMediaQuery("(max-width: 400px)");

  return (
    <Stack
      direction="row"
      spacing={isSmallPhone ? 1 : 1.5} // 📱 manji razmak na manjim telefonima
      alignItems="center"
      justifyContent="center"
      sx={{
        width: "100%",
        maxWidth: isSmallPhone ? 260 : 320, // 📏 limit širine
        border: "2px solid",
        borderColor: "primary.main",
        borderRadius: isSmallPhone ? "24px" : "32px", // 📉 manji radius na malim ekranima
        padding: isSmallPhone
          ? "clamp(4px, 2vw, 10px) clamp(8px, 4vw, 20px)" // 📐 smanjen padding
          : "clamp(8px, 3vw, 16px) clamp(16px, 6vw, 32px)",
        backgroundColor: "rgba(10, 126, 124, 0.2)",
        marginBottom: isMobile ? 2 : 0,
        boxSizing: "border-box",
      }}
    >
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          fontSize: isSmallPhone
            ? "clamp(10px, 3vw, 14px)"
            : "clamp(12px, 3vw, 16px)",
          fontWeight: 700,
        }}
      >
        YOU HAVE
      </Typography>
      <Typography
        variant="h2"
        sx={{
          color: "text.primary",
          fontSize: isSmallPhone
            ? "clamp(14px, 5vw, 22px)"
            : "clamp(18px, 5vw, 28px)",
          fontWeight: 700,
          lineHeight: isSmallPhone
            ? "clamp(16px, 6vw, 28px)"
            : "clamp(22px, 6vw, 36px)",
        }}
      >
        {formatCoinCount(coins)}
      </Typography>
    </Stack>
  );
};
